/// <reference path="../_references.ts"/>

module App.PriceGuide {
	import Department = App.Appointments.Department;

	export type SearchParams = {
		search?: string;
		query?: string;
		department?: number;
		from_template?: number|boolean;
		category?: number|string;
		sub_category?: number|string;
		tag?: string;
		selected?: string;
		orderBy?: string;
		sort?: 'asc' | 'desc';
		favorites?: boolean;
		custom?: boolean;
		service_request?: number;
		only_name?: boolean;
		page?: number;
		size?: number;
		public?: number|boolean;
		show_safe_tech_info?: boolean;
	};

	export type SubCategory = {
		id: number;
		name: string;
	};

	export type ServiceCategory = {
		id: number;
		name: string;
		department?: Department;
		sub_categories: SubCategory[];
	};

	export type ServicePriceOverride = {
		id: number;
		amount: number;
	};

	export type Product = {
		id: number;
		quantity?: number;
		new_quantity?: number;
		name?: string;
		description?: string;
		material_cost?: number;
		department?: number;
		service_department?: number; // department or this is required
		labor_minutes?: number;
		service_price_override?: ServicePriceOverride;
		while_here_with_out_agreement?: number;
		while_here_with_agreement?: number;
		service_request_id?: number;
		code?: string;
		index?: number;
		can_show_regular_pricing?: boolean;
		tax_exempt?: boolean;
	};

	export interface ReturnedProduct {
		id: number;
		quantity: number;
		service: Product;
		index?: number;
	}

	export interface EditedReturnedProduct extends ReturnedProduct {
		new_quantity: number;
		new_price?: number;

		is_new: boolean;
		is_done: boolean;
		is_date: boolean;
		start_date?: Date;
		start_time?: Date;
		end_date?: Date;
		end_time?: Date;

		create_service?: Product;

		original_set: boolean;
		original_quantity: number;
		original_name: string;
		original_description: string;
		original_price?: number;

		last_quantity: number;
		last_name: string;
		last_description: string;
		last_price?: number;
	}

	export type PackageSummary = {
		id?: number;
		quantity: number;
		service_id: number;
		index?: number;
	};

	export type Banner = {
		id: number;
		active: boolean;
		text: string;
		color: string;
	};

	export type PriceItemized = {
		service: string;
		servicemonthly: string;
		regular: string;
		volume: string;
		volumemonthly: string;
		whilehere: string;
		whileheremonthly: string;
		display: string;
	};

	export type PriceRegular = {
		regular: string;
		service: string;
		servicemonthly: string;
	};

	export type PriceWhileHere = {
		regular: string;
		regularnormally: string;
		service: string;
		servicenormally: string;
		servicemonthly: string;
	};

	export type Prices = {
		itemized: PriceItemized;
		regular: PriceRegular;
		whilehere: PriceWhileHere;
	};

	export type PackagePresetName = {
		id: number;
		name: string;
		description: string;
	};

	export type PackagePresetNotes = {
		id: number;
		name: string;
		short_name: string;
	};

	export type Package = {
		[key: string]: any;

		id?: number;
		code: string;
		name: string;
		presetName?: string | null;
		presetNote?: string | null;
		description?: string;
		banner?: Banner;
		prices?: Prices;
		mode?: 'admin' | 'regular' | 'whilehere' | 'itemized';
		services: Array<Product | PackageSummary | ReturnedProduct | EditedReturnedProduct>;
		selectedNote?: string;
		warranty?: Warranty;
		index?: number;
		discount?: string;
		can_show_regular_pricing?: boolean;
		force_hide_regular?: boolean;
		packageAction?: string;
	};

	export type Warranty = {
		description?: string;
		id?: number;
		min_invoice_amount?: number;
		month_duration?: number;
		name: string;
		organization: number;
	};

	export type PackagePresetNote = {
		id: number;
		visible: boolean;
		short_name: string;
		name: string;
	}
}
